import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

import { KnowledgeBaseEditor } from '@/components/settings/knowledge/kb-editor';

export const Route = createFileRoute('/_app/settings/knowledge/$id/')({
  component: KnowledgeBaseDetailRoute,
});

function LoadingFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

function KnowledgeBaseDetailRoute() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <KnowledgeBaseEditor kbId={id} />
    </Suspense>
  );
}
